module.exports = __webpack_public_path__ + "static/media/rewards-title.cc0816bd.png";